import { createFileRoute, redirect } from '@tanstack/react-router'

import { loginSearchSchema } from '@/features/auth/login-search'
import { hasValidToken, safeRedirect } from '@/features/auth/session'
import { SignInScreen } from '@/features/auth/sign-in'

export const Route = createFileRoute('/login')({
  validateSearch: (search) => loginSearchSchema.parse(search),
  // Already signed in: straight on to where the member was going.
  beforeLoad: ({ search }) => {
    if (hasValidToken()) throw redirect({ href: safeRedirect(search.redirect), replace: true })
  },
  component: SignInScreen,
})
